<script setup lang="ts">
import CommentsDashboard from "@/comments/CommentsDashboard.vue";
import {
  useCreateHouseComment,
  useDeleteHouseComment,
  useGetHouseComments,
  useUpdateHouseComment,
} from "@/comments/useHouseComments";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import type { House } from "./types";

const props = defineProps<{
  house: House;
}>();

const { comments, getHouseCommentsStatus } = useGetHouseComments(
  props.house.id,
);
const {
  createComment,
  createHouseCommentStatus,
  error: createHouseCommentError,
} = useCreateHouseComment(props.house.id);
const { updateComment } = useUpdateHouseComment(props.house.id);
const {
  deleteComment,
  deleteHouseCommentStatus,
  reset: resetDeleteHouseComment,
} = useDeleteHouseComment(props.house.id);
</script>

<template>
  <HandleQueryStatus :query-status="getHouseCommentsStatus">
    <CommentsDashboard
      :comments="comments"
      :creating-status="createHouseCommentStatus"
      :creating-error="createHouseCommentError"
      :deleting-status="deleteHouseCommentStatus"
      @create="createComment"
      @update="updateComment"
      @delete="deleteComment"
      @initiate-delete="resetDeleteHouseComment"
    />
  </HandleQueryStatus>
</template>
